import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {debounce} from 'lodash';
import {NavbarSearchPropTypes} from "../utils/propTypes";

export default class Titlebar extends Component {
    constructor() {
        super();
        this.executeSearch = debounce(this.executeSearch, 500);
    }

    componentDidUpdate() {
        // Set focus to the search input when its opened
        if (this.props.search.isOpen) {
            this.searchQuery.focus();
        }
    }

    onSearchInputChange() {
        // Show the loading indicator right when the search input is changed.
        this.props.showLoadingIndicator();
        const query = this.searchQuery.value;

        // Trigger the actual search, that is debounced
        this.executeSearch(this.props.activeTab, query);
    }

    executeSearch(tab, query) {
        this.props.onSearch(tab, query);
    }

    render() {
        let renderedComponent = <span>{this.props.title}</span>;
        let iconClass = 'search-icon fa fa-search';
        let iconOnClick = this.props.onOpenSearch;

        if (this.props.search.isOpen) {
            renderedComponent = (<input
                ref={(ref) => { this.searchQuery = ref; }}
                onChange={() => this.onSearchInputChange()}
                className="search-bar"
                placeholder="Search..."
            />);
            iconClass = 'search-icon search-icon--reset fa fa-times';
            iconOnClick = this.props.onClearSearch;
        }

        let addNewButton = null;
        if (this.props.showAddNewButton) {
            addNewButton = <i className="add-new-icon fa fa-user-plus" onClick={this.props.onAddNewUserButtonClick} />;
        }

        return (
            <div className="titlebar">
                <div className="container">
                    {renderedComponent}
                    {addNewButton}
                    <i className={iconClass} onClick={iconOnClick} />
                </div>
            </div>
        );
    }
}

Titlebar.propTypes = {
    onClearSearch: PropTypes.func.isRequired,
    onOpenSearch: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    onAddNewUserButtonClick: PropTypes.func.isRequired,
    showLoadingIndicator: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    activeTab: PropTypes.oneOf(['COURSE', 'PLAYERS']),
    search: NavbarSearchPropTypes,
    showAddNewButton: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Titlebar.js